export function EmptyState({ icon = 'fa-folder-open', title, description, action }) {
  return (
    <div className="card flex flex-col items-center justify-center px-6 py-14 text-center">
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-canvas text-mist">
        <i className={`fa-solid ${icon} text-lg`} aria-hidden="true" />
      </div>
      {title && <p className="text-sm font-medium text-ink">{title}</p>}
      {description && <p className="mt-1 max-w-md text-sm text-mist">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
